var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"primary notifications-settings",attrs:{"flat":""}},[_c('div',{staticClass:"notifications-settings-title"},[_vm._v(" "+_vm._s(_vm.$t('uiComponents.settings.notification.title'))+" ")]),_c('div',{staticStyle:{"display":"flex"}},[_c('ConChecker',{staticStyle:{"margin-top":"10px"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }